import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { organizationQueryOptions } from '@/core/components/organizations/organizationQueryOptions'
import { propertiesQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/create-collection/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    // PropertyManager is read-only on Collections (it can list them but never
    // create one), which is why it is excluded here and not on the Groups
    // equivalent.
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger'] ||
      auth.user?.role === Role.PropertyManager
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth } }) => {
    const organizations = queryClient.ensureQueryData(
      organizationQueryOptions(auth.token!)
    )
    // Feeds the member multi-select: it has to know every property so it can
    // narrow them down to the independent hotels of the chosen organization.
    const properties = queryClient.ensureQueryData(
      propertiesQueryOptions(auth.token!)
    )

    return { organizations, properties }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
